(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5323],{

/***/ 40919:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/announcement/[id]",
      function () {
        return __webpack_require__(95304);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5248);

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (_index__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 5248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28677);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _layout_MainLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81842);
/* harmony import */ var _components_pages_news_ListNav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6790);
/* harmony import */ var _utils_hooks_news_useNoticeData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81264);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71649);
/* harmony import */ var _styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _layout_centerLayout_CenterLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33134);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88984);













var ImageView = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 714).then(__webpack_require__.bind(__webpack_require__, 50714));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50714)
            ];
        }
    },
    ssr: false
});
function Page(param) {
    var apiData = param.apiData;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var id = router.query.id;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("pages", {
        keyPrefix: "news.announcement"
    }), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,_utils_hooks_news_useNoticeData__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), hookData = ref1.data;
    var data = hookData || apiData;
    var detail = id ? data.find(function(item) {
        return item.id === id;
    }) : data === null || data === void 0 ? void 0 : data[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageView, {
                contentRef: contentRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_MainLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                headProps: {
                    title: t("meta.title"),
                    keyword: t("meta.keyword"),
                    canonical: "https://www.bitop.com".concat(i18n.language === "en" ? "/en" : "", "news/announcement")
                },
                pageClassName: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_centerLayout_CenterLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    detail: detail,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
                        children: id === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageList),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pages_news_ListNav__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().listNav),
                                defaultlist: apiData,
                                tab: "/announcement",
                                listHook: _utils_hooks_news_useNoticeData__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
                            }, Date.now())
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().contents),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                                children: detail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                            children: "【".concat(t("type.".concat(detail.type)), "】 ").concat(detail.title)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                            className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().time),
                                            children: i18n.language === "en" ? moment__WEBPACK_IMPORTED_MODULE_8___default()(detail.time).format("[Published on] MMM Do, YYYY") : moment__WEBPACK_IMPORTED_MODULE_8___default()(detail.time).format("YYYY年MM月DD日[发布]")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: contentRef,
                                            className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().detail),
                                            dangerouslySetInnerHTML: {
                                                __html: detail.content
                                            }
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_pages_news_announcement_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().empty),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_10__/* .NoData */ .J, {})
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
Page.propTypes = {
    apiData: prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)
};
Page.defaultProps = {
    apiData: []
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 6790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28677);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43412);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88984);
/* harmony import */ var _ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28258);
/* harmony import */ var _ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10__);













function ListNav(param) {
    var defaultlist = param.defaultlist, tab = param.tab, className = param.className, listHook = param.listHook;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var locale = router.locale, query = router.query;
    var ref2 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("pages", {
        keyPrefix: "news.announcement"
    }), t = ref2.t, i18n = ref2.i18n;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), page = ref3[0], setPage = ref3[1];
    var ref4 = listHook({
        lang: locale,
        page: page
    }), data = ref4.data, end = ref4.end;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), list = ref5[0], setList = ref5[1];
    var listData = list || defaultlist || [];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (data) {
            setList(function(prevlist) {
                var _newList;
                var newList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(prevlist || []);
                (_newList = newList).push.apply(_newList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data.filter(function(item) {
                    return newList.every(function(i) {
                        return i.id !== item.id;
                    });
                })));
                return newList;
            });
        }
    }, [
        data
    ]);
    var id = (query === null || query === void 0 ? void 0 : query.id) || ((ref = list || defaultlist) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, className, !!className)),
        children: [
            listData.length ? listData.map(function(item) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active), Number(id) === Number(item.id))),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/news".concat(tab, "/").concat(item.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/news".concat(tab, "/").concat(item.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                                        children: [
                                            item.type !== undefined ? "【".concat(t("type.".concat(item.type)), "】") : "",
                                            item === null || item === void 0 ? void 0 : item.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().time),
                                        children: i18n.language === "en" ? moment__WEBPACK_IMPORTED_MODULE_6___default()(item.time || item.date).format("[Published on] MMM Do, YYYY") : moment__WEBPACK_IMPORTED_MODULE_6___default()(item.time || item.date).format("YYYY年MM月DD日[发布]")
                                    })
                                ]
                            })
                        })
                    })
                }, item.id);
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().empty),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_8__/* .NoData */ .J, {})
            }),
            tab !== "/stories" || end ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                variant: "plane",
                onClick: function() {
                    return setPage(function(prevPage) {
                        return prevPage + 1;
                    });
                },
                children: t("loadmore")
            })
        ]
    });
}
ListNav.propTypes = {
    defaultlist: prop_types__WEBPACK_IMPORTED_MODULE_12___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    tab: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    listHook: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().func)
};
ListNav.defaultProps = {
    defaultlist: [],
    className: "",
    tab: "",
    listHook: function() {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ListNav);


/***/ }),

/***/ 81264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16314);


var requestConfig = {
    url: "/api/discover/index.htm?type=1,2,3,4,5,6,7,8"
};
function useNoticeData() {
    var ref = (0,_useRequest__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(requestConfig), data = ref.data, error = ref.error;
    var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: ((data === null || data === void 0 ? void 0 : data.notices) || []).sort(function(a, b) {
                    if (a.top === true && b.top === false) return -1;
                    if (a.top === false && b.top === true) return 1;
                    if (a.time < b.time) return 1;
                    return -1;
                })
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNoticeData);


/***/ }),

/***/ 28258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"ListNav_root_include_ru__mRtut","footer":"ListNav_footer__Nmbb6","container":"ListNav_container__9aO7l","title":"ListNav_title__SCpe4","time":"ListNav_time__m4DC5","empty":"ListNav_empty__a2dzH"};

/***/ }),

/***/ 71649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"announcement_root_include_ru__w6_iS","footer":"announcement_footer__cYQ0T","title":"announcement_title__4QME7","twitter":"announcement_twitter__d8Apy","contents":"announcement_contents__FOfLF","detail":"announcement_detail__lbFbU","container":"announcement_container__VrQM_","listNav":"announcement_listNav__8Vkt9","pageList":"announcement_pageList__wV38s","time":"announcement_time___yKer","empty":"announcement_empty__f6IiU"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3123,1842,9290,8984,6922,4571,9774,2888,179], function() { return __webpack_exec__(40919); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);